document.addEventListener('DOMContentLoaded', function() {
  const imgBox = document.querySelector('.js-ttl-animation');

  // 要素が存在するか確認
  if (!imgBox) return;

  const images = imgBox.querySelectorAll('img');

  // 初期状態の設定
  images.forEach((img, index) => {
    img.style.opacity = '0';
    img.style.transform = 'translateY(105%)';
    // img.style.transition = 'transform ease-in-out 0.3s';
    img.style.transition = 'transform cubic-bezier(0.22, 1, 0.14, 1) 1.5s';
    img.style.transitionDelay = `${index * 0.06}s`;
    // GPU加速の有効化
    img.style.willChange = 'transform, opacity';
  });

  // ちょっとだけ遅らせてアニメーション開始
  requestAnimationFrame(() => {
    setTimeout(() => {
      images.forEach(img => {
        img.style.opacity = '1';
        img.style.transform = 'translateY(0)';
      });
    }, 400);

    // アニメーション完了後にwill-changeを解除
    const lastImage = images[images.length - 1];
    lastImage.addEventListener('transitionend', () => {
      images.forEach(img => {
        img.style.willChange = 'auto';
      });
    });
  });
});